import { useEffect, useRef, useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { useWeb3 } from '@/hooks/use-web3';
import { GETSTAKE, GETSTAKECOUNT, PoolState, STATE } from '@/lib/common/name-space';
import { promiseAllSettled } from '@/lib/Promise';
import { ResGetStakeCall, ResGetStakeCallAddIndex } from '@/types';
import PortfolioDetailTable from './table/portfolio/PortfolioDetailTable';
import UnstakingModal from './modal/UnstakingModal';
import CommonButton from './CommonButton';
import { GridColDef } from '@mui/x-data-grid';
import { portfolioUnStakedDetailColumns } from './table/ColumnsData';
import PortfolioUnStakedCard from './card/PortfolioUnStakedCard';

export default function UnStakeList({ contractAddr }: { contractAddr: string }) {
  const [list, setList] = useState<ResGetStakeCallAddIndex[] | null>(null);
  const [address, setAddress] = useState('');
  const [isOpenUnstakingModal, setIsOpenUnstakingModal] = useState(false);
  const unStakeIndex = useRef<string>('');
  const [state, setState] = useState('');

  const { web3authCall } = useWeb3();
  const theme = useTheme();

  // media query
  const isMobile = useMediaQuery('(max-width:900px)');

  useEffect(() => {
    (async () => {
      if (web3authCall?.connected()) {
        const addr = await web3authCall.getAddress();
        setAddress(addr);
      }
    })();
    return () => {};
  }, [web3authCall]);
  useEffect(() => {
    if (address && contractAddr) {
      (async () => {
        const cnt = await getStakeCount();
        const re = await getStake(cnt);
        setList(re);
        const state = await setStateFunc();
        setState(state);
      })();
    }

    return () => {};
  }, [address, contractAddr]);

  const getStakeCount = async (): Promise<string> => {
    return await web3authCall?.callStaking(GETSTAKECOUNT, contractAddr, [address]);
  };

  const getStake = async (aCnt: string): Promise<ResGetStakeCallAddIndex[] | null> => {
    const arrStake = [];
    for (let i = 0; i < Number(aCnt); i++) {
      arrStake.push(() => web3authCall?.callStaking(GETSTAKE, contractAddr, [address, String(i)]));
    }
    const re = await promiseAllSettled(arrStake);
    const res = re.map((item: ResGetStakeCall, index: number) => ({
      ...item,
      index: String(index),
    }));
    return res;
  };
  const setStateFunc = async (): Promise<string> => {
    return await web3authCall?.callStaking(STATE, contractAddr);
  };
  // method
  const handleOpenModal = (type: string) => {
    unStakeIndex.current = type;
    console.log(type);
    // 인덱스를 받아서 UnstakingModal넘겨주자
    setIsOpenUnstakingModal(true);
  };

  const addColumns: GridColDef[] = [
    ...portfolioUnStakedDetailColumns,
    // ※ 확장자 .ts에서는 renderCell을 불러올 수가 없어서 해당 기능만 추가
    {
      flex: 1,
      minWidth: 100,
      field: 'index',
      headerName: 'Status',
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <CommonButton
          sx={{ borderRadius: '5px', padding: '4px 20px', width: '80px' }}
          handleClick={() => {
            handleOpenModal(params.value);
          }}
          text="Unstake"
          // text={params.value === 'claim' ? 'Claim' : 'Unstake'}
          color="#ffffff"
          bgColor={'#357AFF'}
          variant="body2"
        />
      ),
    },
  ];
  return (
    <>
      <Box
        sx={{
          maxWidth: '1680px',
          padding: '16px 24px',
          marginTop: '16px',
          marginBottom: '38px',
        }}
      >
        {isMobile ? (
          <>
            {state === PoolState.POOLSTATE_FUNDRAISING ? (
              <>
                <Typography variant="h3" color={theme.greyscale.darkgrey2} sx={{ marginBottom: '16px' }}>
                  Unstaked Detail
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {list &&
                    list.map((item) => (
                      <PortfolioUnStakedCard key={item.index} item={item} handleOpenModal={handleOpenModal} />
                    ))}
                </Box>
              </>
            ) : (
              ''
            )}
          </>
        ) : (
          <>
            {state === PoolState.POOLSTATE_FUNDRAISING ? (
              <>
                <Typography variant="h3" color={theme.greyscale.darkgrey2} sx={{ marginBottom: '16px' }}>
                  Unstaked Detail
                </Typography>
                {list && <PortfolioDetailTable list={list} columns={addColumns} />}
              </>
            ) : (
              ''
            )}
          </>
        )}
      </Box>
      <UnstakingModal
        open={isOpenUnstakingModal}
        handleClose={() => setIsOpenUnstakingModal(false)}
        contractAddr={contractAddr}
        stakeIndex={unStakeIndex.current}
      />
    </>
  );
}
